import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, ISagaCb, PaginationType } from '@typings/requestPayloads'

export interface IListWithCompanyPayload extends ISagaCb {
    pagination?: PaginationType
    query?: any
    necessaryProjectionArray?: string[]
    needPopulate?: boolean
    populates?: string[]
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listWithCompany = createSlice({
    name: 'sharedList/list-with-company',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListWithCompanyPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const listWithCompanyActions = listWithCompany.actions
export default listWithCompany.reducer
